module.exports = __webpack_public_path__ + "static/media/napa-valley-logo-new@2x.5d14a78b.png";